import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { isDetailPage } from '@/components/Search'
const useRouteBack = () => {
  const router = useRouter()

  const limitList = [
    '/products/[id]',
    '/shops/[id]',
    '/influencers/[id]',
    '/live/[id]',
    '/videos/[id]',
    '/hashtags/[id]'
  ]

  useEffect(() => {
    const handleRouteChangeComplete = (url: any) => {
      if (isDetailPage(router.pathname) && limitList.includes(router.pathname)) {
        // 是详情页的话，则刷新, 解决详情页之间跳转数据不变化的问题
        router.reload()
      }
    }

    router.events.on('routeChangeComplete', handleRouteChangeComplete)

    return () => {
      router.events.off('routeChangeComplete', handleRouteChangeComplete)
    }
  }, [router])
}

export default useRouteBack
